export const mutations ={
     STORE_TRANSPORTERS (state, transporters) {
         state.transporters = transporters
     },

     STORE_TRANSPORTER_UPDATE (state, transporterId) {
         let Transporter = state.transporters.find(function(transporter){
             return transporter.id === transporterId
         })
         state.systemTransporter = Transporter
     }
}
export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/transporters/mutations.js